import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import {ProductInfoContent} from "./ProductInfoContent";

export default function ProductInfoDialogue({open, onClose, selectorContractGridAPI
                                        }) {

    const handleCloseInfo = () => {
        onClose(true);
    };

    const info = ProductInfoContent(selectorContractGridAPI);

    return (
        <>

            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    {info.title}
                </DialogTitle>

                <DialogContent>
                    {info.content}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseInfo}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    );
}